module.exports = __webpack_public_path__ + "img/arrow-right-paginator.1ba04d52.svg";